import React from 'react'
import Modal from 'react-bootstrap/Modal'
import { useDispatch, useSelector } from 'react-redux'
import { showModal } from '../../redux/ui/actions'
import { getDataObject } from '../../redux/state'
import { modalIsVisible } from '../../redux/ui/state'
import GuestList from './GuestList'

export const GuestListModal = props => {
  const { resource, id } = props
  const dispatch = useDispatch()

  const data = useSelector(state => getDataObject(state, resource, id))

  const show = useSelector(state => modalIsVisible(state, `guestlist-${resource}`, id))

  if (!data) return null

  const handleClose = () => {
    dispatch(showModal(`guestlist-${resource}`, id, false))
  }

  return (
    <Modal
      show={show}
      aria-labelledby="guestlist-modal"
      centered
      onHide={handleClose}
      size="xl"
      backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title id="guestlist-modal">{data.name} Guest List</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <GuestList id={id} />
      </Modal.Body>
    </Modal>
  )
}

export default GuestListModal
